export default __webpack_public_path__ + "static/media/logo.2e7fb2ab.svg";